// KAN-156: account-level notification preferences, cached client-side.
// The server copy (GET/PUT /api/notifications/preferences) is the source of
// truth so settings follow the admin across devices; the cache lets the
// listener decide instantly whether to play a sound.
import { notifications as notifApi } from '@/lib/api';

export const PREFS_CHANGED_EVENT = 'expresssub:notification-prefs-changed';
const CACHE_KEY = 'expresssub_notification_prefs';

export const DEFAULT_NOTIFICATION_PREFS = { position_filled_sound: true };

export const getCachedNotificationPrefs = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return { ...DEFAULT_NOTIFICATION_PREFS, ...(raw ? JSON.parse(raw) : {}) };
  } catch (_e) {
    return { ...DEFAULT_NOTIFICATION_PREFS };
  }
};

const cacheAndBroadcast = (prefs) => {
  const merged = { ...DEFAULT_NOTIFICATION_PREFS, ...(prefs || {}) };
  try { localStorage.setItem(CACHE_KEY, JSON.stringify(merged)); } catch (_e) { /* storage full/blocked */ }
  window.dispatchEvent(new CustomEvent(PREFS_CHANGED_EVENT, { detail: merged }));
  return merged;
};

export const fetchNotificationPrefs = async () => {
  const res = await notifApi.getPreferences();
  return cacheAndBroadcast(res.data);
};

export const saveNotificationPrefs = async (patch) => {
  const res = await notifApi.updatePreferences(patch);
  return cacheAndBroadcast(res.data);
};

/** Update the local cache from a server-computed value (e.g. event payload). */
export const syncPositionFilledSoundFromServer = (value) => {
  if (typeof value !== 'boolean') return;
  const current = getCachedNotificationPrefs();
  if (current.position_filled_sound !== value) {
    cacheAndBroadcast({ ...current, position_filled_sound: value });
  }
};
